<div class="global-overlay-page">
  <div style="margin-right:80px;">
    <h2>{{ clientName }}</h2>
  </div>

  <div class="topbar">

    <mat-form-field appearance="outline" class="custom-select-padding" style="width: 250px;">
      <mat-label>Select academic year</mat-label>
      <mat-select (selectionChange)="selectAcademicYear($event.value)">
        @for (year of academicYears; track year) {
        <mat-option [value]="year.formatted_year">{{year.formatted_year}}</mat-option>
        }
      </mat-select>
    </mat-form-field>


    <div class="menu">
      <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="custom-select-padding" style="width: 200px; margin-right: 15px;">
          <mat-label>From date</mat-label>
          <input matInput [matDatepicker]="fromPicker" formControlName="fromDate" (dateChange)="onSubmit()"
            (blur)="onSubmit()">
          <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
          @if (submitted && f.fromDate.errors?.date) {
          <mat-error>Valid Date Required</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="custom-select-padding" style="width: 200px; margin-right: 15px;">
          <mat-label>To date</mat-label>
          <input matInput [matDatepicker]="toPicker" formControlName="toDate" (dateChange)="onSubmit()"
            (blur)="onSubmit()">
          <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
          @if (submitted && f.toDate.errors?.date) {
          <mat-error>Valid Date Required</mat-error>
          }
        </mat-form-field>

        <button type="submit" class="btn">Search</button>
      </form>

    </div>

    <div class="toolbar">
      <a (click)="downloadReflections()">
        Download Reflections
      </a>

      <a (click)="downloadFeedback()">
        Download Feedback
      </a>
    </div>



  </div>

  <mat-table #table [dataSource]="loading ? [] : dataSource" matSort>
    <ng-container matColumnDef="client">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Client</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.client_name }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="code">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Code</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.code }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="description">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.description }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="number_of_submissions">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Count</mat-header-cell>
      <mat-cell *matCellDef="let element">{{
        element.number_of_submissions
        }}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>

  @if (loading) {
  <div class="skeleton-container">
    @for (row of skeletonRows; track $index) {
    <div class="skeleton-row-flex">
      @for (weight of row; track $index) {
      <div class="skeleton-bar" [style.flex-grow]="weight"></div>
      }
    </div>
    }
  </div>
  }

  @if (!loading && dataSource.data.length == 0) {
  <div style="padding: 20px; text-align: center; color: #666; font-style: italic;">
    No data available
  </div>
  }

</div>